"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_ATTRIBUTE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.ADD_ATTRIBUTE = (0, gql_1.gql)(`
  mutation addAttribute($productLabelValidation: AddProductLabelValidationInput!, $sort: [ProductTreeNodeRelativeOrderBy!]!) {
    addProductLabelValidation(productLabelValidation: $productLabelValidation) {
      error
      success
      productTreeNode {
        ancestors(first: 100, sort: $sort) {
          edges {
            node {
              ancestor {
                id
              }
            }
          }
        }
      }
    }
  }
`);
